import { render, staticRenderFns } from "./what-we-do.vue?vue&type=template&id=2d7b0d1e&"
import script from "./what-we-do.vue?vue&type=script&lang=js&"
export * from "./what-we-do.vue?vue&type=script&lang=js&"
import style0 from "./what-we-do.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports